<template>
  <div class="container-admin">
    <div class="title-admin">{{adminKey== 0? "관리자 등록":"관리자 수정" }}</div>

    <div class="box-admin-input">닉네임 <br><el-input class="input-admin" v-model="nickName" maxlength="20"></el-input>
      <div class="input_error" v-html="validation.firstError('nickName') "></div></div>
    <div class="box-admin-input">연락처 <br><el-input class="input-admin" v-model="phoneNum" type="number" :minlength="10" maxlength="11" show-word-limit pattern:></el-input>
      <div class="input_error" v-html="validation.firstError('phoneNum') "></div></div>
      <div class="box-admin-button">
        <button class="btn-admin btn-admin-cancel" @click="closePopup">취소</button>
        <button class="btn-admin btn-admin-save" @click="writeAdmin">{{adminKey== 0? "등록":"저장" }}</button>

      </div>
  </div>
</template>

<script>
  import EventBus from "@/utils/event-bus";
  import filterMixins from "@/mixins/filterMixins";
  import listMixins from "@/mixins/listMixins";
  import alertMixins from "@/mixins/alertMixins";
  import adminUtil from "@/components/admin/adminUtil";
  import util from "@/mixins/util";
  import adminValidator from "@/mixins/validators/adminValidator";
  const {filterConfig} = adminUtil;

  export default {
      name: "AdminWriteComponent",
      mixins: [filterMixins,listMixins,alertMixins,adminUtil,adminValidator],
      components: {},
      provide() {
          return {
              setPage: this.setPage,

          }
      },
      inject: ['closePopup'],
      props: {
        adminType: {default: ''},
        adminKey :{default:0}
      },
      data() {
          return {
            writeFunc: '',
            parsingData: {},
            keyName: '',
            writeApiParamSet:{},
            adminData:{},
            writeFailTypes:{},
          }
      },
      created() {
        this.initConfig();
        if(this.adminKey === 0) {
            this.initTemplateConfig();
        }else{
            this.getDetail();
        }
      },
      mounted() {
      },
      beforeDestroy() {},
      destroyed() {},
      computed: {
      },
      methods: {
          setData(type, value) {
              this[type] = value;
          },
          initTemplateConfig() {
            let config = this.returnAdminConfig(this.adminType);
            this.writeLayouts = config.writeLayouts;
        },
        initConfig() {
            let config = this.returnAdminConfig(this.adminType);
            this.writeFunc = config.writeFunc;
            this.parsingData = config.parsingData;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeFailTypes = config.writeFailTypes;
            this.keyName = config.keyName;
            this.nickName= ''
            this.phoneNum= ''
        },
        getDetail() {
            let params = {
              id: this.adminKey
            };
            this.$api.$admin.getAdmin(params).then(res=> res.Data.Result).then(res => {
                if(!res.List[0]) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.closePopup();
                        }
                    });
                    return;
                }
                this.adminData = res.List[0];
                this.nickName = this.adminData.a_nick;
                this.phoneNum = this.adminData.a_hp;
            })
        },
        _checkValidator(){
            let validatorArr = Object.keys(this.parsingData);
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    return success
                }
                return success;
            })
        },
        _makeParams(){
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })
            if(this.adminKey != 0) {
                params[this.keyName] = this.adminKey;
            }
            return params;
        },
        async writeAdmin() {
          if(this.isRunning) return false;
            this.changeLoading(true)
            let validator = await this._checkValidator();
            if(!validator){
              this.changeLoading(false);
                return;
            }
            let params = this._makeParams();
            try {
                this.$api.$admin[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let status = res.Info.status;
                    if(!status) {
                      let msg = this.writeFailTypes[res.Info.type];
                        this.errorAlert(msg);
                        this.changeLoading(false);
                        return ;
                    }
                    this.afterFunc();
                    return;
                })
            }catch (e) {
              this.changeLoading(false);
                return;
            }
        },
        afterFunc() {
          this.changeLoading(false);
          this.createAlert({
              title: '',
              content: this.adminKey== 0 ? '등록되었습니다.' : '저장되었습니다.',
              btnText: '확인',
              hide: () => {
                  EventBus.$emit('getList');
                  this.closePopup();
              }
          })
        },
        changeLoading(value){
            this.isRunning = value;
            EventBus.$emit('apiLoading',value);
        },
      },
      watch: {},
  }
</script>

<style scoped>

</style>
